<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/methanol')">甲醇</span> > <span
        @click="back('/methanol/twoPage/productPrice')">下游产品价格</span> > 正文
    </div>
    <DetailTitle :title="$route.query.id+'甲醇下游产品价格'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        style="width: 100%;margin-top: 20px;">
      <el-table-column
          align="center"
          prop="druidParamName"
          width="300"
          label="指标名称">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in tabHead" :key="index">
        <template slot="header">
          <span>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="floatPrice"
          label="涨跌幅">
        <template slot-scope="scope">
          <FloatPrice :floatPrice="scope.row['floatPrice']"/>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="unitName"
          label="单位">
        <template slot-scope="scope">
          <span>{{scope.row['unitName']}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {productPriceDetail} from '@/api/methanol'

export default {
  components: {
    DetailTitle
  },
  data() {
    return {
      tableData: [],
      tabHead: [],
      queryParams:{
        dictDataType:'issue_methanol_product_price',
        endTime:'',
        dataType:1
      }
    }
  },
  created() {
    this.queryParams['endTime'] = this.$route.query.id;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      productPriceDetail(this.queryParams).then(res => {
        this.tableData = res.data.data;
        this.tabHead = res.data['titleList'];
      })
    },
    back(url) {
      this.$router.push({path:url});
    },
  },
  mounted() {
    this.getDetail();
    /**
     * 加载地图
     */
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding: 0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 30px;
  }
}

.hover {
  background-color: #D3131A !important;
  border: 1px solid #D3131A !important;
  color: #fff;
}

.back{
  span {
    cursor: pointer;
  }
}
.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}

.gray {
  color: #999999;
}
</style>
